import { useMutation, useQueryClient } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";

import { AUTOMATION_COLLECTIONS_QUERY_KEY } from "./useFetchAutomationCollections";

/**
 * Deletes a group from an automation collection.
 * @param id - The automation collection ID.
 * @param groupId - The group ID to delete.
 * @returns The updated automation collection or response from backend.
 */
const deleteAutomationGroup = async ({
  id,
  groupId
}: {
  id: string;
  groupId: string;
}) => {
  const response = await axios.delete(
    `${AUTOMATION_SERVICE_ADDRESS}/automation/${id}/groups/${groupId}`
  );
  return response.data;
};

export default function useDeleteAutomationGroup() {
  const queryClient = useQueryClient();
  return useMutation(deleteAutomationGroup, {
    onSuccess: () => {
      queryClient.invalidateQueries(AUTOMATION_COLLECTIONS_QUERY_KEY);
    }
  });
}
